import React from 'react';
import PropTypes from 'prop-types';
import { HorizontalFlex } from 'smartsuite-ui';
import { PadContainer } from 'smartsuite-ui/lib/containers/PadContainer';

export default function StatusCellsLegend({ thresholds }) {
    return (
        <HorizontalFlex cssClassModifiers={['justify-center', 'flex-wrap']}>
            {thresholds.map(threshold => (
                <PadContainer
                    key={threshold.id}
                    cssClassModifiers={['pad-medium']}
                >
                    <HorizontalFlex>
                        <span
                            style={{ backgroundColor: threshold.color }}
                            className="status-cell__indicator"
                            title={threshold.value}
                        />
                        <PadContainer cssClassModifiers={['pad-medium']}>
                            {threshold.label}
                        </PadContainer>
                    </HorizontalFlex>
                </PadContainer>
            ))}
        </HorizontalFlex>
    );
}

StatusCellsLegend.propTypes = {
    thresholds: PropTypes.instanceOf(Array).isRequired
};
